<p-dialog header="{{ fieldAddEditHeader }}" [(visible)]="displayAddField" (onHide)="dialogClose()" [modal]="true"
    [responsive]="true" [style]="{ width: '50vw' }">
    <div class="card">
        <form [formGroup]="fieldDetailsForm" novalidate>
            <div class="p-grid">
                <div class="p-col-12" [ngClass]="{'p-md-5': (operationModules.includes(selectedModule?.objectId)),'p-md-6': !(operationModules.includes(selectedModule?.objectId))}">
                    <label>Field To Update <span style="color: red;">*</span></label>
                    <p-dropdown formControlName="selectedField" [options]="availableFields" (onChange)="selectField()" [filter]="true" appendTo="body" placeholder="Select Field"
                        optionLabel="labelname" [disabled]="viewOnly"></p-dropdown>
                </div>
                <div *ngIf="(operationModules.includes(selectedModule?.objectId))" class="p-col-12 p-md-2">
                    <label><span pTooltip="Operation Type" tooltipPosition="top">Op Type</span></label>
                    <p-dropdown formControlName="operationType" [options]="operationTypes" appendTo="body" placeholder="Select Update Type"
                        optionLabel="name" optionValue="id" [disabled]="viewOnly || !operationFormControlIds.includes(fieldDetailsForm.getRawValue().selectedField?.formControlId)"></p-dropdown>
                </div>
                <div class="p-col-12" [ngClass]="{'p-md-5': (operationModules.includes(selectedModule?.objectId)), 'p-md-6': !(operationModules.includes(selectedModule?.objectId))}">
                    <label>{{ fieldDetailsForm.value?.operationType | workflowUFOT }} Value <span *ngIf="fieldDetailsForm.getRawValue().selectedField?.isrequired" style="color: red;">*</span></label>

                    <div *ngIf="fieldDetailsForm.getRawValue().selectedField" class="p-field p-grid p-mb-0">
                        <ng-container [ngSwitch]="fieldDetailsForm.getRawValue().selectedField.formControlId">

                            <!-- Input Box -->
                            <ng-container *ngSwitchCase="customFieldIds.INPUT">
                                <div class="p-col-12">
                                    <ng-container [ngSwitch]="fieldDetailsForm.getRawValue().selectedField?.field">
                                        <ng-container *ngSwitchCase="'repConfidence'">
                                            <p-inputNumber formControlName="newValue" :min="0" :max="99" maxlength="3" inputId="percent" suffix="%" placeholder="%">
                                            </p-inputNumber>
                                        </ng-container>
                                        <ng-container *ngSwitchDefault>
                                            <input pInputText type="text" formControlName="newValue" placeholder="Enter New Value" />
                                        </ng-container>
                                    </ng-container>
                                </div>
                            </ng-container>

                             <!-- MULTI_LINE -->
                             <ng-container *ngSwitchCase="customFieldIds.MULTI_LINE">
                                <div class="p-col-12">
                                    <textarea pInputTextarea type="text" formControlName="newValue" placeholder="Enter New Value" rows="5"></textarea>
                                </div>
                            </ng-container>

                             <!-- RICHTEXT -->
                             <ng-container *ngSwitchCase="customFieldIds.RICHTEXT">
                                <div class="p-col-12">
                                    <p-editor [style]="{'height':'100px'}" formControlName="newValue" placeholder="Enter New Value" rows="5">
                                        <p-header>
                                            <span class="ql-formats">
                                                <select class="ql-size">
                                                    <option value="small">small</option>
                                                    <option selected></option>
                                                    <option value="large">large</option>
                                                    <option value="huge">huge</option>
                                                </select>
                                            </span>
                                            <span class="ql-formats">
                                                <select class="ql-size">
                                                    <option value="24px">24</option>
                                                    <option value="48px">48</option>
                                                    <option value="100px">100</option>
                                                    <option value="200px">200</option>
                                                </select>
                                            </span>
                                            <span class="ql-formats">
                                                <button class="ql-bold" aria-label="Bold"></button>
                                                <button class="ql-italic" aria-label="Italic"></button>
                                                <button class="ql-underline" aria-label="Underline"></button>
                                                <button class="ql-strike" aria-label="Strike"></button>
                                            </span>
                                            <span class="ql-formats">
                                                <select title="Text Color" class="ql-color"></select>
                                                <span class="ql-format-separator"></span>
                                                <select title="Background Color" class="ql-background"></select>
                                            </span>
                                            <span class="ql-formats">
                                                <button class="ql-list" value="ordered"></button>
                                                <button class="ql-list" value="bullet"></button>
                                                <select title="Text Alignment" class="ql-align">
                                                    <option selected>Gauche</option>
                                                    <option value="center" label="Center"></option>
                                                    <option value="right" label="Right"></option>
                                                    <option value="justify" label="Justify"></option>
                                                </select>
                                            </span>
                                            <span class="ql-formats">
                                                <button aria-label="Link" class="ql-link"></button>
                                            </span>
                                        </p-header>
                                    </p-editor>
                                </div>
                            </ng-container>

                            <!-- Email -->
                            <ng-container *ngSwitchCase="customFieldIds.EMAIL">
                                <div class="p-col-12">
                                    <input pInputText type="text" formControlName="newValue" placeholder="Enter New Value" />
                                </div>
                            </ng-container>

                            <!-- PHONE -->
                            <ng-container *ngSwitchCase="customFieldIds.PHONE">
                                <div class="p-col-12">
                                    <input pInputText type="text" formControlName="newValue" placeholder="Enter New Value" />
                                </div>
                            </ng-container>

                            <!-- URL -->
                            <ng-container *ngSwitchCase="customFieldIds.URL">
                                <div class="p-col-12">
                                    <input pInputText type="text" formControlName="newValue" placeholder="Enter New Value" />
                                </div>
                            </ng-container>

                            <!-- BARCODE -->
                            <ng-container *ngSwitchCase="customFieldIds.BARCODE">
                                <div class="p-col-12">
                                    <input pInputText type="text" formControlName="newValue" placeholder="Enter New Value" />
                                </div>
                            </ng-container>

                            <!-- IPADDRESS -->
                            <ng-container *ngSwitchCase="customFieldIds.IPADDRESS">
                                <div class="p-col-12">
                                    <input pInputText type="text" formControlName="newValue" placeholder="Enter New Value" />
                                </div>
                            </ng-container>

                            <!-- ENCRYPTEDTEXT -->
                            <ng-container *ngSwitchCase="customFieldIds.ENCRYPTEDTEXT">
                                <div class="p-col-12">
                                    <p-iconField iconPosition="right">
                                        <p-inputIcon *ngIf="showEncryptedText" styleClass="pi pi-eye" (click)="showEncryptedText=!showEncryptedText" />
                                        <p-inputIcon *ngIf="!showEncryptedText" styleClass="pi pi-eye-slash" (click)="showEncryptedText=!showEncryptedText"/>
                                        <input pInputText formControlName="newValue" placeholder="Enter New Value" [type]="'text'" [style]="!showEncryptedText ? '-webkit-text-security: disc;':''" />
                                    </p-iconField>
                                </div>
                            </ng-container>

                            <!-- TIME -->
                            <ng-container *ngSwitchCase="customFieldIds.TIME">
                                <div class="p-col-12">
                                    <input pInputText type="time" formControlName="newValue" placeholder="Enter New Value" />
                                </div>
                            </ng-container>

                            <!-- PERCENTAGE -->
                            <ng-container *ngSwitchCase="customFieldIds.PERCENTAGE">
                                <div class="p-col-12">
                                    <p-inputNumber
                                        formControlName="newValue" placeholder="Enter New Value"
                                        [minFractionDigits]="0"
                                        [maxFractionDigits]="(fieldDetailsForm.getRawValue().selectedField?.maxLengthAfterDecimal||6)">
                                    </p-inputNumber>
                                </div>
                            </ng-container>

                            <!-- CURRENCY -->
                            <ng-container *ngSwitchCase="customFieldIds.CURRENCY">
                                <div class="p-col-12">
                                    <p-inputNumber
                                        formControlName="newValue" placeholder="Enter New Value"
                                        [prefix]="fieldDetailsForm.getRawValue().selectedField?.currencySymbol ? fieldDetailsForm.getRawValue().selectedField?.currencySymbol.trim() : currencySymbol" 
                                         [minFractionDigits]="0"
                                        [maxFractionDigits]="(fieldDetailsForm.getRawValue().selectedField?.maxLengthAfterDecimal||6)">
                                    </p-inputNumber>
                                </div>
                            </ng-container>

                            <!-- Number -->
                            <ng-container *ngSwitchCase="customFieldIds.NUMBER">
                                <div class="p-col-12">
                                    <ng-container *ngIf="fieldDetailsForm.getRawValue().fieldValueType!=2">
                                        <ng-container *ngIf="![accountModuleId,leadModuleId].includes(selectedModule?.objectId)">
                                            <p-inputNumber
                                                formControlName="newValue" placeholder="Enter New Value"
                                                (keypress)="isNumberKey($event)">
                                            </p-inputNumber>
                                        </ng-container>
                                        <span *ngIf="[accountModuleId,leadModuleId,salesOrderModuleId,estimateOrderModuleId,invoiceOrderModuleId].includes(selectedModule?.objectId)" class="p-input-icon-right w-100">
                                            <i (click)="openExpressionAdd()" class="pi pi-plus cursor-pointer" pTooltip="Add Expression"></i>
                                            <p-inputNumber
                                                formControlName="newValue" placeholder="Enter New Value"
                                                (keypress)="isNumberKey($event)">
                                            </p-inputNumber>
                                        </span>
                                    </ng-container>
                                    <ng-container *ngIf="fieldDetailsForm.getRawValue().fieldValueType==2">
                                        <span *ngIf="[accountModuleId,leadModuleId,salesOrderModuleId,estimateOrderModuleId,invoiceOrderModuleId].includes(selectedModule?.objectId)" class="text-input-prefix with-edit-icon p-input-icon-right w-100">
                                            <span class="prefix">=</span>
                                            <i class="p-d-flex p-ai-center">
                                                <i (click)="openExpressionAdd()" class="pi pi-pencil cursor-pointer" pTooltip="Edit Expression"></i>
                                                <i (click)="removeExpression()" class="pi pi-trash cursor-pointer p-ml-2" pTooltip="Remove Expression"></i>
                                            </i>
                                            <input pInputText type="text" formControlName="newValue" placeholder="Enter New Value" [readOnly]="true" />
                                        </span>
                                    </ng-container>
                                </div>
                            </ng-container>

                            <!-- Decimal -->
                            <ng-container *ngSwitchCase="customFieldIds.DECIMAL">
                                <div class="p-col-12">
                                    <ng-container *ngIf="fieldDetailsForm.getRawValue().fieldValueType!=2">
                                        <ng-container *ngIf="![accountModuleId,leadModuleId,salesOrderModuleId,estimateOrderModuleId,invoiceOrderModuleId].includes(selectedModule?.objectId)">
                                            <p-inputNumber
                                                formControlName="newValue" placeholder="Enter New Value"
                                                [minFractionDigits]="0" [maxFractionDigits]="(fieldDetailsForm.getRawValue().selectedField?.maxLengthAfterDecimal||6)"
                                                (keypress)="isNumberKey($event)">
                                            </p-inputNumber>
                                        </ng-container>
                                        <span *ngIf="[accountModuleId,leadModuleId,salesOrderModuleId,estimateOrderModuleId,invoiceOrderModuleId].includes(selectedModule?.objectId)" class="p-input-icon-right w-100">
                                            <i (click)="openExpressionAdd()" class="pi pi-plus cursor-pointer" pTooltip="Add Expression"></i>
                                            <p-inputNumber
                                                formControlName="newValue" placeholder="Enter New Value"
                                                [minFractionDigits]="0" [maxFractionDigits]="(fieldDetailsForm.getRawValue().selectedField?.maxLengthAfterDecimal||6)"
                                                (keypress)="isNumberKey($event)">
                                            </p-inputNumber>
                                        </span>
                                    </ng-container>
                                    <ng-container *ngIf="fieldDetailsForm.getRawValue().fieldValueType==2">
                                        <span *ngIf="[accountModuleId,leadModuleId,salesOrderModuleId,estimateOrderModuleId,invoiceOrderModuleId].includes(selectedModule?.objectId)" class="text-input-prefix with-edit-icon p-input-icon-right w-100">
                                            <span class="prefix">=</span>
                                            <i class="p-d-flex p-ai-center">
                                                <i (click)="openExpressionAdd()" class="pi pi-pencil cursor-pointer" pTooltip="Edit Expression"></i>
                                                <i (click)="removeExpression()" class="pi pi-trash cursor-pointer p-ml-2" pTooltip="Remove Expression"></i>
                                            </i>
                                            <input pInputText type="text" formControlName="newValue" placeholder="Enter New Value" [readOnly]="true" />
                                        </span>
                                    </ng-container>
                                </div>
                            </ng-container>

                            <!-- USERLOOKUP -->
                            <ng-container *ngSwitchCase="customFieldIds.USERLOOKUP">
                                <div class="p-col-12">
                                    <p-dropdown formControlName="newValue" [options]="dropdownValues" optionLabel="name" dataKey="name" appendTo="body" placeholder="Select New Value" [showClear]="true" [filter]="true"></p-dropdown>
                                </div>
                            </ng-container>

                            <!-- Dropdown List -->
                            <ng-container *ngSwitchCase="customFieldIds.DROPDOWN">
                                <div class="p-col-12">
                                    <ng-container *ngIf="fieldDetailsForm.getRawValue().selectedField?.field?.toLowerCase()=='accountname'">
                                        <p-autoComplete #parent [suggestions]="dropdownValues" formControlName="newValue" placeholder="Search Account..." field="name" [completeOnFocus]="true" (completeMethod)="searchAllAccounts($event, null)"
                                            appendTo="body" dataKey="id" inputId="parent" name="selectedAccount">
                                        </p-autoComplete>
                                    </ng-container>
                                    <ng-container *ngIf="treeSelectFields.includes(fieldDetailsForm.getRawValue().selectedField?.field?.toLowerCase())">
                                        <liono-treeSelect class="w-100"
                                            [options]="dropdownValues" appendTo="body"
                                            formControlName="newValue"
                                            display="comma"
                                            placeholder="Select New Value"
                                            [filter]="true" [metaKeySelection]="false" selectionMode="single">
                                        </liono-treeSelect>
                                    </ng-container>
                                    <ng-container *ngIf="!['accountname','shippingmethodid','shippingmethod'].includes(fieldDetailsForm.getRawValue().selectedField?.field?.toLowerCase()) && !treeSelectFields.includes(fieldDetailsForm.getRawValue().selectedField?.field?.toLowerCase())">
                                        <p-dropdown formControlName="newValue" [options]="dropdownValues" optionLabel="name" dataKey="name" appendTo="body" placeholder="Select New Value" [showClear]="true" [filter]="true"></p-dropdown>
                                    </ng-container>
                                </div>
                            </ng-container>

                            <!-- Multi Dropdown List -->
                            <ng-container *ngSwitchCase="11">
                                <div class="p-col-12">
                                    <ng-container *ngIf="multiTreeSelectFields.includes(fieldDetailsForm.getRawValue().selectedField?.field?.toLowerCase()) && fieldDetailsForm.getRawValue().selectedField?.field?.toLowerCase()!='uom'">
                                        <liono-treeSelect class="w-100"
                                            [options]="dropdownValues" appendTo="body"
                                            formControlName="newValue"
                                            placeholder="Select Value"
                                            [filter]="true"
                                            [metaKeySelection]="false"
                                            selectionMode="multiple"
                                            display="comma">
                                        </liono-treeSelect>
                                    </ng-container>
                                    <ng-container *ngIf="multiTreeSelectFields.includes(fieldDetailsForm.getRawValue().selectedField?.field?.toLowerCase()) && fieldDetailsForm.getRawValue().selectedField?.field?.toLowerCase()=='uom'">
                                        <liono-treeSelect class="w-100"
                                            [options]="dropdownValues" appendTo="body"
                                            formControlName="newValue"
                                            placeholder="Select Value"
                                            [filter]="true"
                                            [metaKeySelection]="false"
                                            selectionMode="multiple"
                                            (onNodeSelect)="onNodeSelect($event)"
                                            (onNodeUnselect)="onNodeUnselect($event)"
                                            display="comma">
                                        </liono-treeSelect>
                                    </ng-container>
                                    <ng-container *ngIf="!multiTreeSelectFields.includes(fieldDetailsForm.getRawValue().selectedField?.field?.toLowerCase())">
                                        <p-multiSelect formControlName="newValue" [options]="dropdownValues" optionLabel="name" dataKey="name" appendTo="body" placeholder="Select New Value" [showClear]="true"></p-multiSelect>
                                    </ng-container>
                                </div>
                            </ng-container>

                            <!-- Checkbox -->
                            <ng-container *ngSwitchCase="2">
                                <div class="p-col-12">
                                    <div class="p-d-flex p-ai-center p-flex-wrap">
                                        <div class="p-d-flex p-ai-center p-mr-2" *ngFor="let opt of dropdownValues; let j = index;">
                                            <p-checkbox name="checkboxGroup" [value]="opt.name" [formControl]="fieldDetailsForm.controls['newValue']" [inputId]="opt.name"></p-checkbox>
                                            <label [for]="opt.name" class="p-ml-2">{{ opt.name }}</label>
                                        </div>
                                    </div>
                                </div>
                            </ng-container>


                            <!-- Radio Button -->
                            <ng-container *ngSwitchCase="3">
                                <div class="p-col-12">
                                    <div class="p-d-flex p-ai-center p-flex-wrap">
                                        <div class="p-d-flex p-ai-center p-mr-2" *ngFor="let opt of dropdownValues; let j = index;">
                                            <p-radioButton name="newValue" [value]="opt.name" formControlName="newValue" [inputId]="opt.name"></p-radioButton>
                                            <label [for]="opt.name" class="p-ml-2">{{ opt.name }}</label>
                                        </div>
                                    </div>
                                </div>
                            </ng-container>

                            <!-- Date Picker -->
                            <ng-container *ngSwitchCase="9">
                                <div class="p-col-12">
                                    <p-calendar appendTo="body" [monthNavigator]="true" [yearNavigator]="true" [readonlyInput]="true"
                                        placeholder="mm/dd/yyyy" dateFormat="mm/dd/yy" yearRange="1900:2100" [showTime]="false" [showButtonBar]="true"
                                        formControlName="newValue">
                                    </p-calendar>
                                </div>
                            </ng-container>

                            <!-- Date Time Picker -->
                            <ng-container *ngSwitchCase="customFieldIds.DATETIMEPICKER">
                                <div class="p-col-12">
                                    <p-calendar appendTo="body" [monthNavigator]="true" [yearNavigator]="true" [readonlyInput]="true"
                                        placeholder="mm/dd/yyyy hh:mm a" dateFormat="mm/dd/yy" yearRange="1900:2100" [showTime]="true" [hourFormat]="12" [showButtonBar]="true"
                                        formControlName="newValue">
                                    </p-calendar>
                                </div>
                            </ng-container>

                            <!-- Rating -->
                            <ng-container *ngSwitchCase="7">
                                <div class="p-col-12 p-mt-2">
                                    <p-rating [cancel]="false" formControlName="newValue"></p-rating>
                                </div>
                            </ng-container>

                            <!-- Toggle Button -->
                            <ng-container *ngSwitchCase="4">
                                <div class="p-col-12">
                                    <p-toggleButton class="p-mb-2" formControlName="newValue" iconPos="right" onLabel="Yes"
                                        offLabel="No" [onIcon]="'pi pi-check'" [offIcon]="'pi pi-times'">
                                    </p-toggleButton>
                                </div>
                            </ng-container>

                        </ng-container>

                        <small class="custom-fields-error p-invalid" *ngIf="isPatternInvalid(fieldDetailsForm,'newValue')">
                            Please enter a valid {{ fieldDetailsForm.getRawValue().selectedField.formControl }}
                        </small>
                    </div>

                    <input *ngIf="!fieldDetailsForm.getRawValue().selectedField" pInputText type="text" placeholder="Enter New Value" [disabled]="true">
                </div>
            </div>
        </form>
    </div>

    <p-footer>
        <button type="button" pButton (click)="dialogClose()" label="Cancel" class="p-button-secondary"></button>
        <button *ngIf="!viewOnly" type="submit" pButton (click)="saveField()" label="Save"></button>
    </p-footer>
</p-dialog>


<app-add-fields-expression-dialog
    *ngIf="displayAddExpression"
    [displayAddExpression]="displayAddExpression"
    [viewOnly]="viewOnly"
    [expressionText]="expressionText"
    [availableFieldsForExpression]="availableFieldsForExpression"
    (expressionSaved)="saveExpression($event)"
    (dialogClosed)="expressionDialogClose()"
>
</app-add-fields-expression-dialog>
